export default "__VITE_ASSET__13464a60__"